<template>
  <div class="animated fadeIn">
    <div class="black-strip-head d-lg-flex d-sm-flex align-items-center padding_top_25 manage_job_top_anchor new_mobile_display_block justify-content-between">
      <div class="dashboard-headline heading_with_btn">
        <h1 class="center_heading">Telegram Job Broadcast</h1>
        <b-link
          class="btn green-border-btn desktop_margin_left_zero desktop_magin_right_zero"
          @click="exportData"
          v-if="show('export')"
          >Export</b-link
        >
      </div>
    </div>

    <div class="white-bg p-lg-4 p-3 legend_font common_padding_30 top_form_border">
      <b-form @submit.prevent="formSubmit">
        <b-col lg="0" md="0" class="submit-field">
            <div class="single_accordian container broadcast_faq_new">
                <div class="faq-content-box clearfix">
                    <!-- Job ID : This must take in the Job ID and retrieve the Job link-->
                    <div class="submit-field">
                      <h5>Job ID</h5>
                      <multiselect
                        v-model="selectedJob"
                        :options="jobs"
                        :searchable="true"
                        :close-on-select="true"
                        :clear-on-select="true"
                        :show-labels="false"
                        label="job_unique_id"
                        track-by="id"
                        placeholder="Search by Job ID"
                        @input="handleJobSelect"
                        class="new_multi_slec_list job_list_multi_select multiselect_border"
                    />
                    </div>

                    <!-- Message -->
                    <div class="submit-field">
                    <h5>Telegram Message</h5>
                    <b-form-textarea v-model="form.message" class="notification_textarea" placeholder="Enter message content" />
                    </div>


                    <!--Image to attach images-->
                    <div class="submit-field">
                      <h5>Upload Images</h5>
                      <vue-upload-multiple-image @upload-success="uploadImageSuccess" :maxImage="maxImage" :multiple="multiple" @before-remove="beforeRemove" @edit-image="editImage" :showEdit="false" :data-images="images" dragText="Browse" browseText="Select Files"  primaryText="" markIsPrimaryText="" popupText="Image" v-model="form.images" accept=".jpg, .png, .jpeg" limit-exceeded="5" class="customize_delete_icon_file_upload image_glr new_post_image"></vue-upload-multiple-image>
                    </div>

                    <!-- Submit -->
                    <div class="form-btn mt-3">
                    <b-button type="submit" variant="success" class="button">Send Telegram</b-button>
                    </div>
                </div>
            </div>
        </b-col>
      </b-form>
    </div>

    <b-tabs class="my_tab_job tab_header_action_th tab_section_notificaton">
      <b-tab :title="'Sent'" @click="changeTab('sent')">
        <div class="tab-box--head top_custom_head desktop_search_top_div">
          <div class="container new_cnt_pdng my_new_container">
            <div class="row">
            </div>
          </div>
        </div>
        <div class="border-radius-4 white-bg">
          <b-table
            ref="datatableSent"
            show-empty
            striped
            hover
            responsive
            :items="items"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            class="mobile_min_width_1500 add_new_table_border eight_grid_tbl_new"
          >
          <!--The actions column-->
            <template #cell(toggleAction)="items">
              <div class="toggle-action" style="white-space: pre-wrap; word-break: break-word; max-width: 400px;">
                <b-dropdown>
                  <b-dropdown-item @click="resendNotification(items.item.id)" v-if="show('resend')"
                    >Resend
                  </b-dropdown-item>
                  <b-dropdown-item
                    @click="getNotificationData(items.item.id)"
                    v-if="show('duplicate')"
                    >Duplicate
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </template>
            <!-- Job ID -->
            <template #cell(job_id)="data">
              <div style="white-space: pre-wrap; word-break: break-word; max-width: 400px;">
                {{ data.item.job_id }}
              </div>
            </template>

            <!-- Telegram Message -->
            <template #cell(message)="data">
              <div style="white-space: pre-wrap; word-break: break-word; max-width: 500px;">
                <div v-html="data.item.message"></div>
                <div v-if="data.item.job_link" style="margin-top: 6px;">
                  🔗 <a :href="data.item.job_link" target="_blank">View Job Details</a>
                </div>
              </div>
            </template>

            <!-- <template #cell(job_link)="data">
              <div style="white-space: pre-wrap; word-break: break-word; max-width: 400px;">
                {{ data.item.job_link }}
              </div>
            </template> -->

            <!-- Images -->
            <template #cell(image1)="data">
              <div style="white-space: pre-wrap; word-break: break-word; max-width: 400px;">
                <img v-if="data.item.image1" :src="data.item.image1" style="max-height: 80px;" />
              </div>
            </template>

            <template #cell(image2)="data">
              <div style="white-space: pre-wrap; word-break: break-word; max-width: 400px;">
                <img v-if="data.item.image2" :src="data.item.image2" style="max-height: 80px;" />
              </div>
            </template>

            <template #cell(image3)="data">
              <div style="white-space: pre-wrap; word-break: break-word; max-width: 400px;">
                <img v-if="data.item.image3" :src="data.item.image3" style="max-height: 80px;" />
              </div>
            </template>

            <template #cell(send_date)="items">
              <div style="white-space: pre-wrap; word-break: break-word; max-width: 400px;">
                {{ formatDate(items.item.created_at) }}
              </div>
            </template>
          </b-table>
        </div>
        <nav class="pagination-box custom_pagination_border_radius">
          <div class="page-row-box d-inline-block">
            <b-form-group id="input-group-4">
              <span class="d-inline-block">Rows per page</span>
              <span class="d-inline-block">
                <b-form-select v-model="form.rowsPerPage" @change="getTelegramMessageList">
                  <option>25</option>
                  <option>50</option>
                  <option>75</option>
                  <option>100</option>
                </b-form-select>
              </span>
            </b-form-group>
          </div>
          <div class="total-page-count d-inline-block">
            <ul>
              <li>
                <span v-if="totalRows != 0">{{ from }} - {{ to }} of {{ totalRows }}</span>
              </li>
            </ul>
          </div>
          <b-pagination
            :total-rows="totalRows"
            :per-page="perPage"
            v-model="currentPage"
            prev-text=""
            next-text=""
            hide-goto-end-buttons
          />
        </nav>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import { POST_API } from '../../../store/actions.type';
import VueUploadMultipleImage from 'vue-upload-multiple-image';
import moment from "moment";
import Multiselect from "vue-multiselect";

export default {
  name: 'TelegramJobs',
  components: {
    VueUploadMultipleImage,
    Multiselect
  },
  data() {
    return {
      form: {
        jobId: null,
        message: '',
        images: [],
      },
      images: [],
      jobs:[],
      selectedJob: null,
      maxImage: 3,
      multiple: true,      
      filter: '',
      currentTab: 'sent',
      currentPage: 1,
      perPage: 25,
      totalRows: 0,
      sortBy: '',
      isManualMessage: false,
      sortDesc: false,
      sortDirection: 'asc',
      from: 0,
      to: 0,

      items:[],
      fields: [
      { key: "toggleAction", label: "Actions" },
      { key: 'job_id', label: 'Job ID' },
      //{ key: 'job_link', label: 'Link' },
      { key: 'message', label: 'Telegram Message' },
      { key: 'image1', label: 'Image 1' },
      { key: 'image2', label: 'Image 2' },
      { key: 'image3', label: 'Image 3' },
      {
        key: "send_date",
        label: "Scheduled Date & Time",
        sortable: true,
        thStyle: { width: "15%" },
      },
    ],
    }
  },
  methods: {
    show(action) {
      return true
    },
    changeTab(tab) {
      this.currentTab = tab;
      this.getTelegramMessageList();
    },
    formatDate(date) {
      return date ? moment(date).format("DD-MMM-YYYY hh:mm A") : '';
    },
    exportData() {
      console.log("Export clicked");
      // Add your actual export logic later
    },
    beforeRemove(index, file, fileList) {
      console.log("Before remove", file);
    },
    editImage(index, file, fileList) {
      console.log("Edit image", file);
    },
    handleJobSelect(job) {
      if (job && job.id) {
        this.getJobById(job.id);
      }
    },
    getJobById(id) {
      // console.log(moment().subtract(16, 'years').format('DD-MM-YYYY'));
      return this.$store
        .dispatch(POST_API, {
          data: {
            job_id: id,
          },
          api: "/api/notification-upcoming-jobs-byId",
        })
        .then(() => {
          if (this.$store.getters.containsErrors) {
            this.error_message = this.$store.getters.getErrors;
            this.showAlert();
          } else {
            this.selectedCompany = this.$store.getters.getResults.data;
            this.form.job_id = this.$store.getters.getResults.data;
          }
        });
    },
    getJobsListing() {
      return this.$store.dispatch(POST_API, {
        data: {},
        api: "/api/notification-upcoming-jobs", // or a job listing endpoint
      }).then(() => {
        if (this.$store.getters.containsErrors) {
          this.error_message = this.$store.getters.getErrors;
          this.showAlert();
        } else {
          this.jobs = this.$store.getters.getResults.data;
        }
      });
    },

    //still need to fix this function
    resendNotification(id) {
      this.$store
        .dispatch(POST_API, {
          data: {
            id: id,
          },
          api: "/api/telegram-resend-notification",
        })
        .then(() => {
          if (this.$store.getters.containsErrors) {
            this.error_message = this.$store.getters.getErrors;
            this.showAlert();
          } else {
            var msg = "Notification Broadcast Successfully";
            this.showSuccessAlert(msg);
            this.getTelegramMessageList(); //optional refresh
          }
        });
    },
    getNotificationData(id) {
      this.$store
        .dispatch(POST_API, {
          data: { id },
          api: "/api/telegram_duplicate_information",
        })
        .then(() => {
          if (this.$store.getters.containsErrors) {
            this.error_message = this.$store.getters.getErrors;
            this.showAlert();
          } else {
            const data = this.$store.getters.getResults.data;

            // Combine message and job link (if exists)
            this.form.message = (data.message || '') + (data.job_link ? `\n\n<a href="${data.job_link}">🔗 View Job Details</a>` : '');;
            this.selectedJob = { id: data.job_id };
            this.isManualMessage = data.isManualMessage === true;

            // Set only the job ID
            this.selectedJob = {
              id: data.job_id
            };

            // Set image previews if they exist
            this.form.images = [];
            ['image1', 'image2', 'image3'].forEach((key) => {
              if (data[key]) {
                this.form.images.push({
                  name: key + '.jpg',
                  path: data[key],
                  url: data[key]
                });
              }
            });

            // Optional: Scroll to form
            this.$nextTick(() => {
              document.querySelector(".white-bg")?.scrollIntoView({ behavior: 'smooth' });
            });
          }
        });
    },
    getTelegramMessageList() {
      console.log("The Telegram message list was called.")
      return this.$store
        .dispatch(POST_API, {
          data: {
            status: this.currentTab,
            page: this.currentPage,
            rowsPerPage: this.form.rowsPerPage,
            sortDirection: this.sortDirection,
            sortDesc: this.sortDesc
          },
          api: "/api/send-telegram-broadcastlist",
        })
        .then(() => {
          if (this.$store.getters.containsErrors) {
            this.error_message = this.$store.getters.getErrors;
            this.showAlert();
            return [];
          } else {
            const result = this.$store.getters.getResults;
            this.items = result.data;
            this.totalRows = result.total;
            this.perPage = result.per_page;
            this.from = result.from;
            this.to = result.to;
            console.log("Fetched items", this.items);
            return this.items;
          }
        });
    },
    refreshDatatable() {
      this.$refs.datatableSent.refresh();
    },
    uploadImageSuccess(formData, index, fileList) {
      for (let i = 0; i < fileList.length; i++) {
        const file = fileList[i];

        // Check file extension
        const nameParts = file.name.split('.');
        const extension = nameParts[nameParts.length - 1].toLowerCase();
        if (!['jpg', 'jpeg', 'png'].includes(extension)) {
          this.error_message = 'Only .jpg, .jpeg, and .png image files are allowed.';
          fileList.splice(i, 1);
          this.showAlert();
          return;
        }

        // Estimate image size from base64 string
        const base64Length = file.path.length - 'data:image/png;base64,'.length;
        const sizeInBytes = 4 * Math.ceil(base64Length / 3) * 0.5624896334383812;
        const sizeInMB = sizeInBytes / 1000000;

        if (sizeInMB > 5) {
          this.error_message = 'Each image should be less than 5 MB.';
          fileList.splice(i, 1);
          this.showAlert();
          return;
        }

        // Set image preview URL
        file.url = file.path;
      }

      this.form.images = fileList; // update image list for sending
    },
    showAlert() {
      this.$swal({
        position: "center",
        icon: "error",
        title: this.error_message,
        showConfirmButton: false,
        timer: 1500,
      });
    },
    showSuccessAlert(msg) {
      this.$swal({
        position: "center",
        icon: "success",
        iconColor: "#4c8bf5",
        title: msg,
        showConfirmButton: false,
        timer: 1500,
      });
    },
    formSubmit() {
      const uploadedImages = this.form.images;
      const selectedJobData = this.selectedJob || {};
      // Prepare payload to match your backend API
      const payload = {
        job_id: selectedJobData.id || null,
        job_title: selectedJobData.ti || '',
        job_address: selectedJobData.address || '',
        start_date: selectedJobData.start_date || '',
        end_date: selectedJobData.end_date || '',
        start_time: selectedJobData.start_time || '',
        end_time: selectedJobData.end_time || '',
        hourly_cost: selectedJobData.hourly_cost || '',
        job_scope: selectedJobData.job_scope || '',

        message: this.form.message || '',
        image1: uploadedImages[0]?.path || null,
        image2: uploadedImages[1]?.path || null,
        image3: uploadedImages[2]?.path || null,
        isManualMessage: this.isManualMessage,
      };

      // Dispatch to Vuex
      return this.$store.dispatch(POST_API, {
        data: payload,
        api: '/api/send-telegram-broadcast-api',
      })
      .then(() => {
        if (this.$store.getters.containsErrors) {
          this.error_message = this.$store.getters.getErrors;
          this.showAlert && this.showAlert(); // Optional alert method
        } else {
          this.showSuccessAlert && this.showSuccessAlert('Telegram broadcast submitted!');
          // Reset form
          this.form = { title: '', message: '', images: [] };
          this.images = [];
          this.selectedJob = null;
          this.getTelegramMessageList();
        }
      })
      .catch((err) => {
        console.error('Error submitting broadcast:', err);
        alert('Something went wrong while submitting the broadcast.');
      });
    },
  },
  mounted() {
    this.getJobsListing();
    this.getTelegramMessageList();
  }
}
</script>
